import React, { memo } from "react";
import { Grid, Skeleton } from "@mui/material";

function InlineItemLoader() {
  return (
    <Grid container item xs alignItems="center" justifyContent="space-between">
      <Grid item minWidth="1.563rem">
        <Skeleton
          variant="circular"
          width={15}
          height={15}
          sx={{ ml: "0.3rem", width: "100%" }}
        />
      </Grid>
      <Grid item md={1.5} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item minWidth="3.5rem" mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.45} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={1.9} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.72} lg={0.6} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.5} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.3} lg={0.5} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={0.3} lg={0.5} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={1.2} lg={1.2} pl={1.5} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={1} lg={1} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item md={1} lg={1} mr={1}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
      <Grid item minWidth="4rem" mr={2}>
        <Skeleton
          variant="text"
          sx={{
            fontSize: "1.5rem",
            width: "100%",
          }}
        />
      </Grid>
    </Grid>
  );
}

export default memo(InlineItemLoader);
